// extracted by mini-css-extract-plugin
module.exports = {"faqHeadText":"faq_faqHeadText__4GHNB","faq":"faq_faq__m19Eq"};